module.exports = __webpack_public_path__ + "media/site/images/products/ekanban-flat-screen3-87f5313e87e8d87f46434ceee7fa4e5d.png";